import { render, staticRenderFns } from "./department-staff-select.vue?vue&type=template&id=1ed14c98&"
import script from "./department-staff-select.vue?vue&type=script&lang=js&"
export * from "./department-staff-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports